import { ENV } from "src/const/evn";

export const initGA = (): void => {
    const measurementId = ENV.GA_MEASUREMENT_ID;
    if (!measurementId || typeof window === 'undefined') return;

    const script1 = document.createElement('script');
    script1.async = true;
    script1.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
    document.head.appendChild(script1);
    
    const script2 = document.createElement('script');
    script2.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${measurementId}', '${{
        linker: {
          enabled: false
        }
      }}');
    `;
    document.head.appendChild(script2);
  };
  